import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class JsLoaderService {
  loadScripts() {
    const dynamicScripts = [
      "./assets/js/jquery.1.8.3.min.js",
      "./assets/js/wow.min.js",
      //"./assets/js/featherlight.min.js",
      //"./assets/js/featherlight.gallery.min.js",
      "./assets/js/jquery.enllax.min.js",
      //"./assets/js/jquery.easing.min.js",
      "./assets/js/jquery.stickyNavbar.min.js",
      "./assets/js/jquery.waypoints.min.js",
      "./assets/js/images-loaded.min.js",
      //"./assets/js/lightbox.min.js",
      "./assets/js/site.js"
    ];
    for (let i = 0; i < dynamicScripts.length; i++) {
      const node = document.createElement("script");
      node.src = dynamicScripts[i];
      node.type = "text/javascript";
      node.async = false;
      node.charset = "utf-8";
      document.getElementsByTagName("head")[0].appendChild(node);
    }
  }
}
